import { Button, Menu, paperClasses, menuItemClasses, avatarClasses, Divider, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Arrow from "./assets/icons/Arrow.js";
import Employees from "./assets/icons/Employees.js";
import "react/jsx-runtime";
const DropdownButton = styled(Button, {
  shouldForwardProp: (props) => props !== "isOpen"
})(
  ({ theme, isOpen, fullWidth }) => `
    flex-shrink: 0;
    width: auto;

    @media print {
      display: none;
    }

    background-color: ${isOpen ? theme.palette.primary[50] : "inherit"};
    width: ${fullWidth ? "100%" : "initial"};
  `
);
const DropdownText = styled(Button)(
  ({ theme }) => `
    && {
      color: ${theme.palette.common.black};
    }
  `
);
const EmployeesIcon = styled(Employees)(() => ``);
const ArrowIcon = styled(Arrow, {
  shouldForwardProp: (props) => props !== "isOpen"
})(
  ({ isOpen }) => `
    transform: ${isOpen ? "rotate(180deg)" : "none"};
  `
);
const SearchMenu = styled(Menu, {
  shouldForwardProp: (props) => props !== "width" && props !== "maxHeight"
})(
  ({ width, maxHeight }) => `
    & .${paperClasses.root} {
      max-height: ${maxHeight}px;
      width: ${width}px;
    }

    & .${menuItemClasses.root} {
      & .${avatarClasses.root} + span {
        max-width: 102px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  `
);
const SearchDivider = styled(Divider)(({ theme }) => ({
  margin: 0,
  backgroundColor: theme.palette.grey[300]
}));
const RoleCount = styled(Typography)`
  margin-left: 8px;
  display: inline;
`;
export {
  ArrowIcon,
  DropdownButton,
  DropdownText,
  EmployeesIcon,
  RoleCount,
  SearchDivider,
  SearchMenu
};
